import { useCallback, useState } from 'react';
import createUseContext from 'constate';

const useSearchProviders = () => {
  const [searchProvidersConditions, setSearchProvidersConditions] = useState({});
  const [searchProvidersResults, setSearchProvidersResults] = useState({});

  const set = useCallback((conditions, results) => {
    setSearchProvidersConditions(conditions);
    setSearchProvidersResults(results);
  }, []);

  return {
    searchProvidersConditions,
    searchProvidersResults,
    set,
  };
};

const [SearchProvidersProvider, useSearchProvidersContext] = createUseContext(useSearchProviders);

export {
  SearchProvidersProvider,
  useSearchProvidersContext,
};
